import { render, staticRenderFns } from "./text.component.vue?vue&type=template&id=53945e43&scoped=true&"
import script from "./text.component.vue?vue&type=script&lang=js&"
export * from "./text.component.vue?vue&type=script&lang=js&"
import style0 from "./text.component.vue?vue&type=style&index=0&id=53945e43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53945e43",
  null
  
)

export default component.exports